/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { SubscriptionsTableV2SubscriptionFragmentDoc } from '../../../../../components/organization/SubscriptionsTableV2/__generated__/SubscriptionsTable.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type OrganizationSubscriptionsV2IndexPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrganizationSubscriptionsV2IndexPageQuery = { __typename: 'Query', organization: { __typename: 'Organization', id: string, waveSubscriptions?: Array<{ __typename: 'WaveSubscription', id: string, name: string, userGivenName?: string | null, createdAt: any, validUntil: any, status: Types.WaveSubscriptionStatus, productId: string, customers: Array<{ __typename: 'PartialCustomer', name: string }>, usage: { __typename: 'SubscriptionUsage', max?: number | null, current: number } }> | null } };


export const OrganizationSubscriptionsV2IndexPageDocument = gql`
    query OrganizationSubscriptionsV2IndexPage {
  organization {
    id
    waveSubscriptions {
      ...SubscriptionsTableV2Subscription
    }
  }
}
    ${SubscriptionsTableV2SubscriptionFragmentDoc}`;

/**
 * __useOrganizationSubscriptionsV2IndexPageQuery__
 *
 * To run a query within a React component, call `useOrganizationSubscriptionsV2IndexPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSubscriptionsV2IndexPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSubscriptionsV2IndexPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationSubscriptionsV2IndexPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganizationSubscriptionsV2IndexPageQuery, OrganizationSubscriptionsV2IndexPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationSubscriptionsV2IndexPageQuery, OrganizationSubscriptionsV2IndexPageQueryVariables>(OrganizationSubscriptionsV2IndexPageDocument, options);
      }
export function useOrganizationSubscriptionsV2IndexPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationSubscriptionsV2IndexPageQuery, OrganizationSubscriptionsV2IndexPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationSubscriptionsV2IndexPageQuery, OrganizationSubscriptionsV2IndexPageQueryVariables>(OrganizationSubscriptionsV2IndexPageDocument, options);
        }
export type OrganizationSubscriptionsV2IndexPageQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsV2IndexPageQuery>;
export type OrganizationSubscriptionsV2IndexPageLazyQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsV2IndexPageLazyQuery>;
export type OrganizationSubscriptionsV2IndexPageQueryResult = ApolloReactCommon.QueryResult<OrganizationSubscriptionsV2IndexPageQuery, OrganizationSubscriptionsV2IndexPageQueryVariables>;